/* Up select — 「どこから入れたか」と「入れたあと何を押したか」を数える（260811）
 *
 * ■ なぜ要るか
 *   いま `add_to_cart` は **PDP本体・シート・併売・コンシェルジュ・数量＋・カート面** が
 *   ぜんぶ同じ1種類のイベントで混ざっている。8/8夜に「入れても /cart へ飛ばさない」
 *   ようにしてから、カート面は導線から外れた（view_cart/add_to_cart が 131%→51%）。
 *   ＝**いまの主導線＝追加後パネルの「ご購入手続きへ」に、計器が1つも付いていない。**
 *
 * ■ 送り先は GA4（Measurement Protocol）
 *   `channels/ec/checkout_funnel_pixel/pixel.js` と同じ口・同じ鍵を使う（仕組みを写す）。
 *   ⚠️ **新しいパラメータは作らない。** GA4のサービスアカウントは読み取りだけで、
 *      カスタムディメンションを登録できない（403。`ga4_dimensions.py` の決着）。
 *      だから **区別はイベント名に埋め**、登録済みの `event_category` /
 *      `event_label` にだけ載せる。名前は常に読める。
 *
 * ■ 送るもの
 *   atc_pdp / atc_sheet / atc_cross / atc_upc / atc_bar / atc_cart / atc_list / atc_other
 *      … カート投入。どこの何を押した結果か
 *   panel_view / panel_cart / panel_checkout / panel_cross / panel_close
 *      … 追加後パネル（#pdps-added）が出た・その中の何を押したか
 *   bar_checkout … 追随バーが「ご購入手続きへ」になった状態で押された
 *   header_cart … 右上のカートアイコンが押された（＝カート面へのもう1つの入口）
 *   cart_view / cart_checkout / cart_back
 *      … カート面に着いた・購入ボタンを押した・回遊へ戻った（入口と金額つき）
 *   cart_after_add … 入れた直後のカゴ（1点で止まっているのか、2点目が入ったのか）
 *   event_category = 上と同じ区分／event_label = 押した物の素の印（下の「分からなかった」用）
 *
 * ■ 触らない・壊さない
 *   - `fetch` も `XMLHttpRequest` も **包まない**（シート側が clone() で覗いている。
 *     二重に包むと壊れる）。投入の検知は **PerformanceObserver（resource）** で行う。
 *   - 画面には何も足さない。押せるものを増やさない。既存のJSに触らない。
 *   - ⚠️ `/cart/change` `/cart/update` は数えない。お届け日時のアプリが読み込み時に
 *     POSTするので、拾うと「押していないのに入った」ことになる（260808に踏んだ穴）。
 */
(function () {
  'use strict';
  if (window.__upcTrack) return;          /* 二重読み込みで倍にしない */
  window.__upcTrack = true;

  var MEASUREMENT_ID = 'G-TFQWC7RDDH';
  var API_SECRET = 'SF1R4eIHT_CAcX9dEONxOw';
  var ENDPOINT = 'https://www.google-analytics.com/mp/collect?measurement_id='
    + MEASUREMENT_ID + '&api_secret=' + API_SECRET;

  /* ── GA4のセッションに紐づける（pixel.js と同じ読み方） ─────────────── */
  function cookie(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? m[2] : '';
    } catch (e) { return ''; }
  }
  function ids() {
    var ga = cookie('_ga');
    var gs = cookie('_ga_' + MEASUREMENT_ID.replace('G-', ''));
    var m1 = ga.match(/GA\d\.\d\.(\d+\.\d+)/);
    /* 旧 GS1.1.<id> と 新 GS2.1.s<id>$o1$... の両方を受ける（s を許さないと全欠する） */
    var m2 = gs.match(/GS\d\.\d\.s?(\d+)/);
    return {cid: m1 ? m1[1] : null, sid: m2 ? m2[1] : null};
  }

  function send(name, category, label) {
    try {
      var i = ids();
      var params = {engagement_time_msec: 1, page_location: location.href};
      if (i.sid) params.session_id = i.sid;
      if (category) params.event_category = String(category).slice(0, 90);
      if (label) params.event_label = String(label).slice(0, 90);
      var body = JSON.stringify({
        client_id: i.cid || '0.0',
        non_personalized_ads: true,
        events: [{name: name, params: params}]
      });
      if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, body);
      else fetch(ENDPOINT, {method: 'POST', body: body, keepalive: true});
    } catch (e) { /* 計測で店を止めない */ }
  }

  /* ══ 260818 追記：投入→会計の「どこで・なぜ止まったか」を割る ═══════════════
   *
   * ■ 何が割れていなかったか（260818 実測・スマホ6日）
   *   投入84 → 会計28（33%）。パネル直行18は**押した瞬間が会計＝漏れゼロ**、
   *   一方**カート面に着いた54セッションのうち44が止まっている**。ところが
   *   カート面には計器が1つも無かったので、次の3つがどれも出せなかった。
   *     (a) 入口 … パネルの「カートを見る」か、右上のカートアイコンか
   *     (b) 金額 … 止まったカゴは送料無料ライン ¥14,000 の上か下か
   *                （在庫29点の最高が ¥12,800＝**1点では構造上ぜったい届かない**。
   *                  主力 ¥6,800×2点＝¥13,600 も ¥400 足りない）
   *     (c) 2点目 … 入れたあと2点目が入っているのか（品揃えの仮説はここに出る）
   *   ⇒ (a) を `event_category`、(b)(c) を `event_label` に、同じ物差しで載せる。
   *
   * ⚠️ **新しいパラメータは作らない**（サービスアカウントは読み取りだけ＝403。冒頭の決着）。
   *    区別は **イベント名** と、登録済みの `event_category` / `event_label` だけで表す。
   * ⚠️ `/cart.js` は **GET**。シート側のラッパは POST `/cart/add` にしか反応しない
   *    （`apply_pdp_sheet.py:765` で確認）ので素通りする＝壊さない。
   * ⚠️ 読む回数には必ず床を作る。無条件に読むと、お届け日時アプリの `/cart/update` と
   *    組んで無限に叩く（429 を踏んだ形）。
   */

  var FREE = 14000;                     /* 送料無料ライン。判定の芯はこの線の上か下か */
  var ENTRY_KEY = 'upc_cart_entry';
  var ENTRY_MS = 120000;                /* 入口の印は2分で捨てる（別経路で使い回さない） */

  function band(y) {
    if (y < 6000) return '〜5,999';
    if (y < 10000) return '6,000〜9,999';
    if (y < 12000) return '10,000〜11,999';
    if (y < FREE) return '12,000〜13,999';      /* ★線の真下。ここが厚いなら送料が主因 */
    if (y < 17000) return '14,000〜16,999';
    return '17,000〜';
  }

  /* カートの中身。⚠️ 押した瞬間に送れるよう、値は**先に読んで持っておく**
     （押してから読むと /checkout への移動に負けて、その1件が丸ごと落ちる） */
  var cart = null, cartAt = 0, cartBusy = false, cartTimer = 0;
  function readCart(then) {
    if (cart && Date.now() - cartAt < 1200) { if (then) then(cart); return; }
    if (cartBusy) return;
    cartBusy = true;
    /* ★`?upc` は**目印**。この店は /cart.js をもともと何度も読むので、
       目印が無いと「計器が叩きすぎているか」を後から数えられない。 */
    fetch('/cart.js?upc=1', {credentials: 'same-origin',
                             headers: {Accept: 'application/json'}})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        cartBusy = false;
        if (!j) return;
        /* 値段は**最小単位**で来る（JPYは100倍）。自前で桁を作らない */
        cart = {yen: Math.round((j.total_price || 0) / 100), n: j.item_count || 0};
        cartAt = Date.now();
        if (then) then(cart);
      })
      .catch(function () { cartBusy = false; });
  }
  function reread() {                   /* 数量を変えたとき用。床を作って叩きすぎない */
    if (cartTimer) return;
    cartTimer = setTimeout(function () { cartTimer = 0; cartAt = 0; readCart(); }, 700);
  }
  function amt(c) { return '¥' + band(c.yen) + '|n=' + c.n; }
  /* 押した物＋いくらのカゴだったか。値が無ければ**帯を作らない**（嘘の帯を残さない） */
  function mk(what) { return cart ? what + '|' + amt(cart) : what; }

  /* 入口の印。押した瞬間に置いて、/cart 側で読む */
  function mark(where) {
    try { sessionStorage.setItem(ENTRY_KEY, where + '@' + Date.now()); } catch (e) {}
  }
  function takeEntry() {
    var v = '';
    try {
      v = sessionStorage.getItem(ENTRY_KEY) || '';
      sessionStorage.removeItem(ENTRY_KEY);
    } catch (e) { return 'unknown'; }
    var i = v.lastIndexOf('@');
    if (i < 0) return 'direct';
    return (Date.now() - Number(v.slice(i + 1)) < ENTRY_MS) ? v.slice(0, i) : 'direct';
  }

  /* ── (a) 入口その2＝右上のカートアイコン ───────────────────────────── */
  document.addEventListener('click', function (ev) {
    try {
      var e = ev.target;
      if (e && e.nodeType === 3) e = e.parentNode;
      if (!e || !e.closest) return;
      if (e.closest('#cart-icon-bubble, a.header__icon--cart')) {
        mark('header');
        send('header_cart', 'header', location.pathname.slice(0, 60));
      }
    } catch (e) {}
  }, true);

  /* ── (b) カート面。着いた／押した／戻った を、入口と金額で割る ──────────── */
  if (location.pathname.indexOf('/cart') === 0) {
    var entry = takeEntry();
    readCart(function (c) { send('cart_view', entry, amt(c)); });

    /* 数量を変えたら持ち値を入れ替える。
       ⚠️ お届け日時のアプリが読み込み時にも POST するが、ここは**数えていない**
          （投入の検知は上の PerformanceObserver＝`/cart/add` だけ）。 */
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          var n = en.name || '';
          if (n.indexOf('/cart/change') !== -1 || n.indexOf('/cart/update') !== -1) reread();
        });
      }).observe({type: 'resource', buffered: false});
    } catch (e) {}

    document.addEventListener('click', function (ev) {
      try {
        var e = ev.target;
        if (e && e.nodeType === 3) e = e.parentNode;
        if (!e || !e.closest) return;
        /* 購入ボタン。フォームの分と、あとから描かれる追随バーの分の両方を受ける */
        if (e.closest('[name="checkout"], #checkout, a[href^="/checkout"]')) {
          if (!cart) return;              /* 値が無いなら送らない */
          return send('cart_checkout', entry, amt(cart));
        }
        /* 回遊へ戻った＝2点目を探しに行った。品揃えの仮説はここに出る */
        var back = e.closest('a[href*="/products/"], a[href*="/collections/"]');
        if (back) return send('cart_back', entry, mk((back.getAttribute('href') || '').slice(0, 40)));
      } catch (e) {}
    }, true);
  }

  /* ── 最後に指が触れたもの。押してから投入が飛ぶまでの間をつなぐ ────────── */
  var last = null, lastAt = 0;
  ['pointerdown', 'click'].forEach(function (t) {
    document.addEventListener(t, function (ev) {
      var e = ev.target;
      if (e && e.nodeType === 3) e = e.parentNode;      /* 文字を押した場合 */
      if (!e || !e.closest) return;
      last = e; lastAt = Date.now();
    }, true);                                            /* capture＝止められない */
  });

  /* 押した物の素の印。**分からなかったときに、あとから作りを直せるように残す** */
  function raw(e) {
    var out = [];
    for (var n = e, i = 0; n && n.nodeType === 1 && i < 3; n = n.parentElement, i++) {
      var id = n.id ? '#' + n.id : '';
      var cl = (n.className && n.className.toString ? n.className.toString() : '')
        .trim().split(/\s+/).slice(0, 2).join('.');
      out.push((n.tagName || '').toLowerCase() + id + (cl ? '.' + cl : ''));
    }
    return out.join('<');
  }

  /* ── どこから入れたか ────────────────────────────────────────────
   * ⚠️ 名前で決めない。**その場所に本当に居るか**（closest）で決める。
   *    上から順に見る＝内側にあるものが勝つ（併売はパネルの中にある）。
   */
  function where(e) {
    if (!e || !e.closest) return ['other', ''];
    var hint = raw(e);
    if (e.closest('#pdps-added') && e.closest('[data-xs]')) return ['cross', hint];
    if (e.closest('#pdps-added')) return ['cross', hint];   /* パネル内の投入は併売だけ */
    if (e.closest('.upc-panel, .upc-fab')) return ['upc', hint];
    if (e.closest('#pdps-sh')) return ['sheet', hint];
    if (e.closest('#open-variant-modal')) return ['bar', hint];
    if (e.closest('form[action*="/cart/add"]')) {
      return [location.pathname.indexOf('/products/') === 0 ? 'pdp' : 'list', hint];
    }
    if (location.pathname.indexOf('/cart') === 0) return ['cart', hint];
    if (location.pathname.indexOf('/products/') === 0) return ['pdp', hint];
    if (location.pathname.indexOf('/collections/') === 0) return ['list', hint];
    return ['other', hint];
  }

  /* ── 投入の検知＝資源の記録を見る（何も包まない） ───────────────────── */
  var lastAdd = 0;
  function onAdd() {
    var now = Date.now();
    if (now - lastAdd < 800) return;      /* 1回の投入で2本飛ぶことがある */
    lastAdd = now;
    /* 押してから5秒以内なら、その指のせいと見なす（それ以上あいたら分からない） */
    var e = (now - lastAt < 5000) ? last : null;
    var w = e ? where(e) : ['other', 'no-tap'];
    send('atc_' + w[0], w[0], w[1]);
    /* (c) 入れた直後のカゴ。1点で止まっているのか、2点目が入ったのか。
       ⚠️ すぐ読むと**入る前の値**を取るので、少し置いてから読む */
    setTimeout(function () {
      cartAt = 0;
      readCart(function (c) { send('cart_after_add', w[0], amt(c)); });
    }, 700);
  }

  try {
    var po = new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (en) {
        var n = en.name || '';
        /* ⚠️ /cart/add だけ。/cart/change・/cart/update は数えない */
        if (n.indexOf('/cart/add') !== -1) onAdd();
      });
    });
    po.observe({type: 'resource', buffered: true});
  } catch (e) { /* 古い端末では投入の検知は落とす（他は動かす） */ }

  /* JSを使わない素のフォーム送信（面が移る）ぶんは、出ていく前に送る */
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!f || !f.getAttribute) return;
      if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      var w = where(ev.submitter || f);
      lastAdd = Date.now();               /* 下の資源の記録と二重にしない */
      send('atc_' + w[0], w[0], w[1] || 'form');
    } catch (e) {}
  }, true);

  /* ── 入れたあとのパネルと追随バー ──────────────────────────────── */
  document.addEventListener('click', function (ev) {
    try {
      var e = ev.target;
      if (e && e.nodeType === 3) e = e.parentNode;
      if (!e || !e.closest) return;
      if (e.closest('#pdps-added')) {
        if (e.closest('.pdps-b1')) { mark('panel'); return send('panel_cart', 'panel', mk('カートを見る')); }
        if (e.closest('.pdps-b2')) return send('panel_checkout', 'panel', mk('ご購入手続きへ'));
        if (e.closest('.pdps-b3')) return send('panel_close', 'panel', mk('買い物を続ける'));
        if (e.closest('#pdps-ax')) return send('panel_close', 'panel', mk('✕'));
        if (e.closest('[data-xs]')) return send('panel_cross', 'panel', mk('併売'));
        return;
      }
      /* ⚠️ 背面タップ＝これまで計器が無く、離脱が過小に出ていた（260817の残課題） */
      if (e.closest('#pdps-abov')) return send('panel_close', 'panel', mk('背面'));
      var bar = e.closest('#open-variant-modal');
      if (bar) {
        /* 入れたあとのバーは「ご購入手続きへ」に変わる（印は data-pdps-done） */
        send(bar.getAttribute('data-pdps-done') ? 'bar_checkout' : 'bar_open',
             'bar', (bar.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 40));
      }
    } catch (e) {}
  }, true);

  /* パネルが出たこと自体。⚠️ 出ない人が多いのか、出ても押されないのかは別の話 */
  try {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var add = ms[i].addedNodes || [];
        for (var j = 0; j < add.length; j++) {
          var n = add[j];
          if (n.nodeType === 1 && n.id === 'pdps-added') {
            send('panel_view', 'panel', location.pathname.slice(0, 60));
          }
        }
      }
    }).observe(document.body, {childList: true});
  } catch (e) {}
})();
